<!--
 * @Author: your name
 * @Date: 2019-10-24 20:32:55
 * @Description: In User Settings Edit
 -->
<template>
  <div>
    <el-dialog lock-scroll :modal-append-to-body="false"  :append-to-body="true" :title="$lang('编辑订单')" custom-class="j-dialog"
      :close-on-click-modal="false" top="45px" :visible.sync="visible" @close="close" width="960px">
      <div class="overflow">
        <el-form class="el-form-edit" ref="orderForm" :rules="rules" :inline="true" :model="formData" label-position="left"
          label-suffix=" :">
          <!-- <div class="group-title" style="padding:0 0 16px 0;" v-show="comeFrom==='order'">
            <span class="title">寄件人信息</span>
          </div> -->
          <h3 v-if="comeFrom==='order'">{{$lang('寄件人信息')}}</h3>
          <div class="group-content" v-if="comeFrom==='order'">
            <el-form-item :label="$lang('寄件人姓名')" prop="senderName">
              <el-input v-model="formData.senderName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('寄件人电话')" prop="senderMobilePhone">
              <el-input v-model="formData.senderMobilePhone" :placeholder="$lang('请输入')" :maxlength='15'></el-input>
            </el-form-item>
            <el-form-item :label="$lang('寄件人电话') + '2'" prop="senderTelphone">
              <el-input v-model="formData.senderTelphone" :placeholder="$lang('请输入')" :maxlength='15'></el-input>
            </el-form-item>
            <el-form-item :label="$lang('寄件省')" prop="senderProvinceName">
              <el-select v-model="formData.senderProvinceName" filterable @change="dataProvinceChange($event,1)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="(item[labelLang] + '（' + item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('寄件城市')" prop="senderCityName">
                  <el-select v-model="formData.senderCityName" filterable @change="dataCityChange($event,1)">
                    <el-option
                      v-for="item in cityList"
                      :key="item.id"
                      :label="(item[labelLang] + '（' + item.enName + '）')"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$lang('寄件地区')" prop="senderAreaName">
                  <!-- <el-select v-model="formData.senderAreaName" @change="dataAreaChange($event,1)">
                    <el-option
                      v-for="item in areaList"
                      :key="item.id"
                      :label="item[labelLang]"
                      :value="item.id"
                    />
                  </el-select> -->
                  <el-autocomplete
                    class="inline-input"
                    popper-class="my-kqoption"
                    :popper-append-to-body="false"
                    v-model="formData.senderAreaName"
                    :fetch-suggestions="querySearch"
                    :placeholder="$lang('请输入')"
                    :value-key="labelLang"
                    @blur="blurCity($event, 1)"
                    @select="dataAreaChange($event, 1)"
                  ></el-autocomplete>
                </el-form-item>
                <el-form-item :label="$lang('寄件街道')" prop="senderStreet">
                  <el-input v-model.trim="formData.senderStreet" :placeholder="$lang('请输入')" :minlength="1" :maxlength="12"></el-input>
                </el-form-item>
                 <el-form-item :label="$lang('寄件楼号')" prop="sendBuildingNo" style="width:100px;">
                    <el-input v-model="formData.sendBuildingNo" :placeholder="$lang('请输入楼号')"  :minlength="1"  :maxlength="5" />
                </el-form-item>
                <el-form-item :label="$lang('寄件楼层')"  prop="sendFloor">
                   <el-input v-model="formData.sendFloor" :placeholder="$lang('请输入楼层')"  :minlength="1" :maxlength="5"></el-input>
                </el-form-item>
                <el-form-item :label="$lang('寄件房号')" prop="sendRoomNumber" style="width:100px;">
                   <el-input v-model="formData.sendRoomNumber" :placeholder="$lang('请输入房号')"  :minlength="1"  :maxlength="5"></el-input>
                </el-form-item>
                <!-- <el-form-item :label="$lang('寄件备注')" prop="sendRemark">
                   <el-input class="sendRemarkStyle" v-model="formData.sendRemark" :placeholder="$lang('请输入备注')"  :minlength="1"  :maxlength="500"></el-input>
                </el-form-item> -->
            <!-- <el-form-item :label="$lang('省/市/区')" prop="senderProvince">
              <BaseAddress ref="senderProvinceSearch" :showLevel="3" :initAddressData="sendAddressData" v-model="formData.senderProvince">
              </BaseAddress>
            </el-form-item> -->

            <!-- <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="senderDetailedAddress">
              <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="80"></el-input>
            </el-form-item> -->
          </div>
          <!-- <div class="group-title">
            <span class="title">收件人信息</span>
          </div> -->
          <h3>{{$lang('收件人信息')}}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('收件人姓名')" prop="receiverName">
              <el-input v-model="formData.receiverName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('收件人电话')" prop="receiverMobilePhone">
              <el-input v-model="formData.receiverMobilePhone" :placeholder="$lang('请输入')" :maxlength='15'></el-input>
            </el-form-item>
            <el-form-item :label="$lang('收件人电话') + '2'" prop="receiverTelphone">
              <el-input v-model="formData.receiverTelphone" :placeholder="$lang('请输入')" :maxlength='15'></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('省/市/区')" prop="receiverProvince">
              <BaseAddress ref="receiverProvinceSearch" :showLevel="3" :initAddressData="receiverAddressData"
                v-model="formData.receiverProvince"> </BaseAddress>
            </el-form-item> -->
            <el-form-item :label="$lang('收件省')" prop="receiverProvinceName">
              <el-select v-model="formData.receiverProvinceName" filterable :key="formData.receiverProvinceId" @change="dataProvinceChange($event,2)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="(item[labelLang] + '（' + item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('收件城市')" prop="receiverCityName">
              <el-select v-model="formData.receiverCityName" filterable :key="formData.receiverCityId" @change="dataCityChange($event,2)">
                <el-option
                  v-for="item in cityList2"
                  :key="item.id"
                  :label="(item[labelLang] + '（' + item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('收件地区')" prop="receiverAreaName">
                  <!-- <el-select v-model="formData.receiverAreaName" @change="dataAreaChange($event,2)">
                    <el-option
                      v-for="item in areaList2"
                      :key="item.id"
                      :label="item[labelLang]"
                      :value="item.id"
                    />
                  </el-select> -->
              <el-autocomplete
                class="inline-input"
                popper-class="my-kqoption"
                :popper-append-to-body="false"
                v-model="formData.receiverAreaName"
                :fetch-suggestions="querySearch2"
                :placeholder="$lang('请输入内容')"
                :value-key="labelLang"
                @blur="blurCity($event, 2)"
                @select="dataAreaChange($event, 2)"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item :label="$lang('收件街道')" prop="receiverStreet">
              <el-input v-model.trim="formData.receiverStreet" :placeholder="$lang('请输入收件街道')" :minlength="1" :maxlength="500"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('收件楼号')" prop="receiverBuildingNo" style="width:100px;">
                <el-input v-model="formData.receiverBuildingNo" :placeholder="$lang('请输入楼号')"  :minlength="1"  :maxlength="5" />
            </el-form-item>
            <el-form-item :label="$lang('收件楼层')" prop="receiverFloor" id="areaCodeSty">
                <el-input v-model="formData.receiverFloor" :placeholder="$lang('请输入楼层')"  :minlength="1" :maxlength="5"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('收件房号')" prop="receiverRoomNumber" id="areaCodeSty">
                <el-input v-model="formData.receiverRoomNumber" :placeholder="$lang('请输入房号')"  :minlength="1"  :maxlength="5"></el-input>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('派件备注')" prop="receiverRemark" id="areaCodeSty">
                <el-input class="sendRemarkStyle" v-model="formData.receiverRemark" :placeholder="$lang('请输入备注')"  :minlength="1"  :maxlength="500"></el-input>
            </el-form-item> -->
            <!-- <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
              <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="80"></el-input>
            </el-form-item> -->
          </div>
          <!-- <div class="group-title">
            <span class="title">货物信息</span>
          </div> -->
          <h3>{{$lang('货物信息')}}</h3>
             <div class="group-content">
          <el-form-item :label="$lang('物品类型')" prop="goods">
            <Base-Select v-model="formData.goods" :props="{label:'name',value:'code', res:'appArticleTypeVOList',valueObj:true}"
              dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')"></Base-Select>
          </el-form-item>
          <el-form-item :label="$lang('物品名称')" prop="goodsName">
            <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="20"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('物品重量')" prop="packageTotalWeight">
            <el-input-number v-model="formData.packageTotalWeight" label="描述文字" :precision="2" :min="0" :max="999.99"></el-input-number>
          </el-form-item>
          <!-- <el-form-item :label="$lang('尺寸(cm)')" prop="packageNumber" class="sizeSty">
            {{$lang('长')+'\xa0' }}<el-input v-model="formData.packageLength" :placeholder="$lang('请输入')" :minlength="1"  :maxlength="3" oninput="value=value.replace(/[^\d]/g,'')"></el-input>{{'\xa0\xa0' }}
            {{$lang('宽')+'\xa0' }}<el-input v-model="formData.packageWide" :placeholder="$lang('请输入')" :minlength="1"  :maxlength="3" oninput="value=value.replace(/[^\d]/g,'')"></el-input>{{'\xa0\xa0' }}
            {{$lang('高')+'\xa0' }}<el-input v-model="formData.packageHigh" :placeholder="$lang('请输入')" :minlength="1"  :maxlength="3" oninput="value=value.replace(/[^\d]/g,'')"></el-input>{{'\xa0\xa0' }}
          </el-form-item> -->
          <!-- <el-form-item :label="$lang('物品件数')" prop="packageNumber">
            <el-input-number v-model="formData.packageNumber" label="描述文字" :step="1" :precision="0" :min="0" :max="999"></el-input-number>
          </el-form-item> -->
          <!-- <el-form-item :label="$lang('产品类型')" prop="payType">
            <Base-Select v-model="formData.payType" :dic="DIC.payType" :placeholder="$lang('请选择')"></Base-Select>
          </el-form-item> -->
          <!-- <el-form-item :label="$lang('结算方式')" prop="payment">
               <Base-Select v-model="formData.payment" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                    dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                </Base-Select>
              <Base-Select v-model="formData.payment" :dic="DIC.payTypes" :placeholder="$lang('请选择')"
              :props="{label:'name',value:'code',valueObj:true}"></Base-Select>
          </el-form-item> -->
          <el-form-item :label="$lang('支付方式')" prop="paidMode">
            <Base-Select v-model="formData.paidMode" :props="{label:'name',value:'code', res:'appPayTypeVOList',valueObj:true}" :disabled="paidOption"
                dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
            </Base-Select>
        </el-form-item>
           <el-form-item :label="$lang('快递类型')" prop="expressType">
                <Base-Select v-model="formData.expressType" :props="{label:'name',value:'code', res:'appProductTypeVOList',valueObj:true}"
                    dicUrl="/vip/baseData/availableProductlist"  :placeholder="$lang('请选择')" @getNetDicData="expressTypeData">
                </Base-Select>
            </el-form-item>
          <el-form-item :label="$lang('参考运费')" prop="standardValue">
            <el-input v-model="formData.standardValue" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$lang('箱材规格')" prop="boxStandard">
            <Base-Select v-model="formData.boxStandard" :props="{label:'name',value:'id', res:'records',valueObj:true}"
              dicUrl="/vip/material/getMaterialSalesPrice" :placeholder="$lang('请选择')" @change="changeBoxStandard">
            </Base-Select>
          </el-form-item> -->
          <!-- <el-form-item label="箱子数量" prop="boxNumber">
            <el-input-number v-model="formData.boxNumber"  :step="1" :precision="0" :min="0" :max="99"></el-input-number>
          </el-form-item> -->
          <!-- <el-form-item label="箱子单价">
            <el-input v-model="formData.boxPrice" disabled></el-input>
          </el-form-item> -->
          <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
            <el-input v-model="formData.customerOrderId" :placeholder="$lang('请输入')" :minlength="1"  :maxlength="35"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('代收货款币别')" prop="codCurrencyTypeName">
            <el-select v-model="formData.codCurrencyTypeName" >
              <el-option
                v-for="item in codCurrencyType"
                :key="item.codCurrencyTypeCode"
                :label="item.codCurrencyTypeName"
                :value="item.codCurrencyTypeCode"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$lang('代收货款金额')" prop="codMoney">
            <el-input v-model="formData.codMoney" :label="$lang('描述文字')" :disabled="codOption" :placeholder="$lang('请输入对应的金额')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <!-- <el-input-number v-model="formData.codMoney" :disabled="codOption" :placeholder="$lang('请输入')" :step="1" :precision="1" :controls="false" :min="0" :max="99999.9"></el-input-number> -->
          </el-form-item>
          <el-form-item :label="$lang('到付运费金额')" prop="fodMoney">
            <el-input v-model="formData.fodMoney" :placeholder="$lang('请输入到付运费金额')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('是否保价')" prop="insured" class="insured-info">
            <Base-Select v-model="formData.insured" :clearable="false" :dic="DIC.insured" :placeholder="$lang('请选择')"  @change="changeInsured" :props="{label:'name' ,value:'code'}"></Base-Select>
            <!-- <a class="btn-insured" @click="openInsured">{{$lang('保价声明')}}</a> -->
          </el-form-item>
          <el-form-item :label="$lang('保险价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
            <el-input-number ref="declaredValueNumber" v-model="formData.declaredValue" @input.native="declaredValueInput()" :placeholder="$lang('请输入')" :step="1" :precision="2" :controls="false" :min="0" :max="100000"></el-input-number>
          </el-form-item>
          <el-form-item :label="$lang('保价费')" prop="insuredValue" v-show="formData.insured===1">
            <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('客户拣货数量')">
              <el-input-number v-model="formData.customerPickNumber" :label="$lang('描述文字')" step-strictly :min="1" :max="999" ></el-input-number>
          </el-form-item>
          <el-form-item label="" v-if="dialogType === 'batchOrder'">
            <div class="isSigndan" v-if="isSignFlag">
              <el-checkbox v-model="checked" @change="signChange" :disabled="hdFlag">{{ $lang('是否有回单') }}</el-checkbox>
            </div>
          </el-form-item>
          <br>
          <el-form-item v-if="formData.expressTypeCode === 'EX' || formData.expressTypeCode === 'DR'" :label="$lang('Ex/DR描述')" prop="exdrDescription" class="el-form-item el-form-item--small" style="width:33%">
            <el-input v-model="formData.exdrDescription" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="500" resize="none"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('客户拣货信息')" prop="customerPickInfo" class="el-form-item el-form-item--small" style="width:50%">
            <el-input v-model="formData.customerPickInfo" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="500" resize="none" ></el-input>
          </el-form-item>
          <el-form-item :label="$lang('备注')" prop="remarks" style="width:50%">
            <el-input type="textarea" v-model="formData.remarks" :maxlength="500" :rows="4" show-word-limit :label="$lang('描述文字')"></el-input>
          </el-form-item>
             </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <!-- <el-button @click="close">{{ $lang('取消') }}</el-button> -->
        <el-button type="primary" :loading="keyBtn" @click="sumbit" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
      <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
import { DIC } from '@constants'
import { mapGetters } from 'vuex'
import { RULES, phoneAndMobile, integerWeight, isNullObj } from '@utils/rules'
import { getComCost, getSettlement, getComputationCost, getsysCurrencyType, getCalc } from '@api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'
import debounce from 'lodash/debounce'
import * as Api from '@api/base/public'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'EditOrder',
  components: {
    InsuredStatement,
  },
  props: {
    value: {},
    orderData: {
      type: Object,
      default: function() {
        return {}
      },
    },
    comeFrom: {
      type: String,
      default: function() {
        return 'order'
      },
    },
    disablePayment: {
      type: Boolean,
      default: true,
    },
    dialogType: {
      type: String,
      default: function() {
        return ''
      },
    }
  },

  data() {
    return {
      DIC,
      keyBtn: false,
      data: '',
      visible: false,
      infoVisible: false, // 保价费声明弹窗
      paidOption: true,
      cityList: [],
      cityList2: [],
      codOption: false,
      areaList: [],
      areaList2: [],
      provinceArray: [],
      codCurrencyType: [],
      formData: {
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderTelphone: '', // 寄件人手机号,
        senderProvince: {},
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称
        senderStreet: '', // 寄件区域街道
        // senderLocal: '', // 寄件区省/市/区
        // senderDetailedAddress: '', // 寄件详细地址,
        receiverName: '', // 收件人姓名,
        receiverMobilePhone: '', // 收件人手机号,
        receiverTelphone: '',
        receiverProvince: {},
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverStreet: '', // 收件区域名称,

        // receiverLocal: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        insured: 0, // 是否保价1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: '', // 保价费,
        goods: {
          id: 108,
          code: 'ITN4',
          name: 'Others'
        }, // 物品类型
        goodsTypeId: 108, // 物品类型id,
        goodsTypeCode: 'ITN4', // 物品类型编码,
        goodsTypeName: 'Others', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 1, // 物品重量,
        packageNumber: 1, // 物品件数,
        payment: '', // 结算方式
        paymentModeId: '', // 结算方式id,
        paymentModeCode: '', // 结算方式编码,
        paymentModeName: '', // 结算方式名称,
        paidMode: {}, // 支付方式
        paidModeCode: '', // 支付方式code
        paidModeName: '', // 支付方式名称
        paidModeId: '', // 支付方式id
        codCurrencyTypeName: '', // 代收货款币别
        codCurrencyTypeCode: '', // 代收货款币别code
        expressType: '', // 快递类型
        expressTypeCode: '', // 快递类型code
        expressTypeName: '', // 快递类型name
        codMoney: '', // COD,
        codFee: 0, // COD手续费,
        packageLength: '', // 物品长,
        packageWide: '', // 物品宽,
        packageHigh: '', // 物品高,
        standardValue: 0, // 参考运费,
        boxNumber: 1, // 箱材数量,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        packageChargeWeight: 1, // 结算重量,
        customerOrderId: '',
        langType: 'nativeName',
        customerPickNumber: 1,
        customerPickInfo: '',
        signReceipt: '',
        rc: '',
        exdrDescription: '', // EX/DR描述
        fodMoney: '', // 付运费金额
      },
      checked: false,
      rules: {},
      sendAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      startAddressId: null,
      endAddressId: null,
      isSignFlag: false,
      hdFlag: false
    }
  },
  watch: {
    comeFrom: {
      handler(val) {
        if (val === 'order') {
          this.rules = {
            senderName: [RULES.requiredTrim],
            senderMobilePhone: [RULES.required, { validator: phoneAndMobile }],
            senderTelphone: [RULES.lengthEleven, { validator: phoneAndMobile }],
            senderProvinceName: [RULES.requiredSelect],
            senderCityName: [RULES.requiredSelect],
            senderAreaName: [RULES.requiredSelect],
            senderStreet: [RULES.requiredTrim],
            // sendBuildingNo: [RULES.requiredTrim],
            receiverTelphone: [RULES.lengthEleven, { validator: phoneAndMobile }],
            receiverProvinceName: [RULES.requiredSelect],
            receiverCityName: [RULES.requiredSelect],
            receiverAreaName: [RULES.requiredSelect],
            receiverStreet: [RULES.requiredTrim],
            // receiverBuildingNo: [RULES.requiredTrim],
            // goods: [RULES.requiredSelect],
            // goodsName: [RULES.required, { validator: checkGoodsName }],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            // payment: [RULES.requiredSelect],
            // insured: [RULES.requiredSelect],
            // packageNumber: [RULES.required],
            customerOrderId: [RULES.twenty_num_strNew],
            exdrDescription: [RULES.required],
          }
        } else {
          this.rules = {
            receiverName: [RULES.requiredTrim],
            receiverMobilePhone: [RULES.requiredTrim, { validator: phoneAndMobile }],
            receiverTelphone: [RULES.lengthEleven, { validator: phoneAndMobile }],
            receiverProvince: [RULES.requiredSelect, { validator: isNullObj }],
            // receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            // goods: [RULES.requiredSelect],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            // payment: [RULES.requiredSelect],
            // insured: [RULES.requiredSelect],
            // senderProvinceName: [RULES.requiredSelect],
            // senderCityName: [RULES.requiredSelect],
            // senderStreet: [RULES.requiredTrim],
            receiverProvinceName: [RULES.requiredSelect],
            receiverCityName: [RULES.requiredSelect],
            receiverAreaName: [RULES.requiredSelect],
            receiverStreet: [RULES.requiredTrim],
            customerOrderId: [RULES.twenty_num_strNew]
            // receiverBuildingNo: [RULES.requiredTrim],
            // receiverStreet: [RULES.requiredTrim],
            // packageNumber: [RULES.required],
          }
        }
      },
      immediate: true,
    },
    value: {
      handler(val) {
        this.visible = val
      },
      immediate: true,
    },
    orderData: {
      handler(newVal) {
        var val = { ...newVal }
        console.log('orderData-------', val, val.langType)

        // 箱材规格 初始化
        const boxStandard = {
          id: val.boxStandardId,
          materialCode: val.boxStandardCode,
          materialName: val.boxStandardName,
          boxPrice: val.boxPrice,
          salesPrice: val.boxPrice,
          name: val.boxStandardName,
          code: val.boxStandardCode,
        }
        const goods = {
          id: val.goodsTypeId || 108,
          code: val.goodsTypeCode || 'ITN4',
          name: val.goodsTypeName || 'Others',
        }
        // const payment = {
        //   id: val.paymentModeId,
        //   code: val.paymentModeCode,
        //   name: val.paymentModeName,
        // }
        const expressType = {
          code: val.expressTypeCode, // 快递类型code
          name: val.expressTypeName, // 快递类型name
        }

        const paidMode = {
          code: val.paidModeCode, // 支付方式code
          name: val.paidModeName, // 支付方式name
          id: val.paidModeId
        }
        val.codCurrencyTypeName = (!val.codCurrencyTypeName ? 'EGP' : val.codCurrencyTypeName)
        val.codCurrencyTypeCode = (!val.codCurrencyTypeCode ? 'EGP' : val.codCurrencyTypeCode)

        this.formData = { ...val, ...{ boxStandard, goods, expressType, paidMode }}
        this.checked = val.signReceipt === 1 // 是否回单
        // 代收货款金额是否可填
        console.log('this.userInfo.settlementCode111', this.userInfo.settlementCode)
        if (this.userInfo.settlementCode === 'CC_CASH') {
          this.codOption = true
        } else {
          this.codOption = false
        }
        // console.log(this.formData, 2)
        if (this.comeFrom === 'order') {
          this.handleProvice(val.senderProvinceId, 1)
          this.hangdleAreaInfo(val.senderCityId, 1)
        }
        this.handleProvice(val.receiverProvinceId, 2)
        this.hangdleAreaInfo(val.receiverCityId, 2)
        // 初始化 箱材规格
      },
      deep: true,
    },
    checked(val) {
      if (this.isSignFlag && val) {
        this.formData.signReceipt = 1
        this.formData.rc = 'Y'
      } else {
        this.formData.signReceipt = 0
        this.formData.rc = ''
      }
    },
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val || {}
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured, expressTypeCode } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = ''
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = ''
      }
    },
    // 支付方式
    async 'formData.payment'(val) {
      // alert(val)
      if (!val) return
      const ggg = val.id
      console.log('val', ggg)
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val
      if (val.code === 'PP_CASH') {
        this.paidOption = false
      } else {
        this.paidOption = true
        this.formData.paidMode = ''
      }
      this.formData.paymentModeId = ggg
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.formData
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      // 到付现结不支持保价
      if (val.name === '到付现结') {
        Object.assign(this.formData, { insured: 0, declaredValue: '', signReceipt: 0 })
        this.formData.insuredValue = ''
        this.formData.receiptFreight = 0
      }
      console.log(this.formData)
    },
    async 'formData.expressType'(val) {
      const { code, name } = val
      this.$nextTick(() => {
        // 当快递类型为Standard 或 Premium，才可以选择回单；其他均不允许下回单
        this.hdFlag = !(code === 'PR' || code === 'EZ')
        console.log(this.hdFlag, 'hdFlag')
        if (this.hdFlag) this.checked = false
      })
      // 快递类型为DR时 cod禁用
      const obj = {
        'DR': () => { this.codOption = true; this.formData.codMoney = '' },
        'default': () => { this.codOption = false }
      }
      code === 'DR' ? obj[code]() : obj['default']()
      Object.assign(this.formData, { expressTypeCode: code, expressTypeName: name })
      const { senderProvince, receiverProvince, packageTotalWeight, declaredValue, goods, insured } = this.formData
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      if (insured === 1 && goods && parseFloat(declaredValue) > 0 && code) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = ''
      }
    },
    'formData.fodMoney'(val) {
      const { fodMaxAmount } = this.userInfo
      if (fodMaxAmount && val > fodMaxAmount) {
        this.$message.error(`${this.$lang('到付运费金额不能超过')}${fodMaxAmount}! ${this.$lang('请重新输入')}`)
        this.formData.fodMoney = ''
        return
      } else if (parseFloat(val) > 99999) {
        this.$message.error(this.$lang('到付运费金额不能超过99999！请重新输入'))
        this.formData.codMoney = ''
        return
      } else if (toString(val).indexOf('.') !== -1 && toString(val).split('.')[1].length > 2) {
        this.$message.error(this.$lang('到付运费金额不能超过2位小数！请重新输入'))
        this.formData.fodMoney = ''
        return
      }
    },
    // 代收货款手续费计算
    async 'formData.codMoney'(val) {
      // debugger
      const { codMoney } = this.formData
      const { codMaxAmount, isOpenCod } = this.userInfo
      if (parseFloat(codMoney) > 0) {
        if (isOpenCod === 2) {
          this.$message.error(this.$lang(`未开通COD`))
          this.formData.codMoney = ''
          return
        } else if (parseFloat(codMoney) > codMaxAmount) {
          this.$message.error(`${this.$lang('代收货款不能超过')}${codMaxAmount}! ${this.$lang('请重新输入')}`)
          this.formData.codMoney = ''
          return
        } else if (parseFloat(codMoney) > 99999.9) {
          this.$message.error(this.$lang('代收货款不能超过99999.9！请重新输入'))
          this.formData.codMoney = ''
          return
        } else if (toString(codMoney).indexOf('.') !== -1 && codMoney.split('.').length > 2) {
          this.$message.error(this.$lang('代收货款不能有多个小数点！请重新输入'))
          this.formData.codMoney = ''
          return
        } else if (toString(codMoney).indexOf('.') !== -1 && codMoney.split('.')[1].length > 1) {
          this.$message.error(this.$lang('代收货款不能超过一位小数！请重新输入'))
          this.formData.codMoney = ''
          return
        }
        const codFeeParam = { collectionfee: codMoney }
        const res = await getCalc(codFeeParam)
        Object.assign(this.formData, { codFee: (res.data !== undefined && res.data !== null ? res.data : 0) })
      } else {
        this.formData.codMoney = ''
        this.formData.codFee = ''
      }
    },

    // 长
    async 'formData.packageLength'(val) {
      const { packageLength } = this.formData
      if (parseFloat(packageLength) <= 0) {
        this.formData.packageLength = ''
        return
      }
    },
    // 宽
    async 'formData.packageWide'(val) {
      const { packageWide } = this.formData
      if (parseFloat(packageWide) <= 0) {
        this.formData.packageWide = ''
        return
      }
    },
    // 高
    async 'formData.packageHigh'(val) {
      const { packageHigh } = this.formData
      if (parseFloat(packageHigh) <= 0) {
        this.formData.packageHigh = ''
        return
      }
    },
    // 运费计算
    // async 'formData.senderProvince'(val) {
    //   // debugger
    //   const obj = {
    //     senderProvinceId: val.provinceId,
    //     senderProvinceName: val.provinceName,
    //     senderCityId: val.cityId,
    //     senderCityName: val.cityName,
    //     senderAreaId: val.areaId,
    //     senderStreet: val.areaName,
    //   }
    //   Object.assign(this.formData, obj)
    //   const { receiverProvince, packageTotalWeight } = this.formData
    //   if (receiverProvince && packageTotalWeight > 0) {
    //     const res = await this.calcStandardCost(this.formData)
    //     Object.assign(this.formData, res)
    //   }
    // },
    // 运费计算
    // async 'formData.receiverProvince'(val) {
    //   const { senderProvince, packageTotalWeight } = this.formData
    //   const obj = {
    //     receiverProvinceId: val.provinceId,
    //     receiverProvinceName: val.provinceName,
    //     receiverCityId: val.cityId,
    //     receiverCityName: val.cityName,
    //     receiverAreaId: val.areaId,
    //     receiverStreet: val.areaName,
    //   }
    //   Object.assign(this.formData, obj)
    //   if (senderProvince && packageTotalWeight > 0) {
    //     const res = await this.calcStandardCost(this.formData)
    //     Object.assign(this.formData, res)
    //   }
    // },
    // 物品重量
    async 'formData.packageTotalWeight'(val) {
      const { senderProvince, receiverProvince } = this.formData
      if (senderProvince && receiverProvince && val > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 保价费计算
    // async 'formData.declaredValue'(val) {
    //   const { goods, insured, expressTypeCode } = this.formData
    //   if (insured === 1 && goods && parseFloat(val) > 0 && expressTypeCode) {
    //     const res = await this.getComputationCost(this.formData)
    //     Object.assign(this.formData, { insuredValue: res })
    //   } else {
    //     this.formData.insuredValue = ''
    //   }
    // },
    // async 'formData.senderMobilePhone' (val) {
    //   console.log(val)
    //   if (val && !val.startsWith('+')) {
    //     this.formData.senderMobilePhone = '+' + this.formData.senderMobilePhone
    //   }
    // },
    // 'formData.receiverMobilePhone': {
    //   handler (val) {
    //     console.log(val)
    //     if (val && !val.startsWith('+')) {
    //       this.formData.receiverMobilePhone = '+' + this.formData.receiverMobilePhone
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    labelLang() {
      const { langType = 'nativeName' } = this.orderData
      console.log(this.orderData, langType)
      return langType === 'EN' ? 'enName' : 'nativeName'
    },
  },
  created() {
    this.getProList()
    this.getCurrencyTypeList()
    if (this.formData.insured === 1) { // 是否保价1是，0否,
      this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    }
  },
  mounted() {
    this.calcStandardCost(this.formData)
  },
  methods: {
    // 保价费计算
    declaredValueInput: debounce(async function (e) {
      const val = this.$refs.declaredValueNumber.displayValue
      const { goods, insured, expressTypeCode } = this.formData
      this.formData.declaredValue = val
      if (insured === 1 && goods && parseFloat(val) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = ''
      }
    }, 300),
    signChange(val) {
      this.checked = val
    },
    expressTypeData(data, type, result) {
      if (result) {
        this.isSignFlag = true
      } else {
        this.isSignFlag = false
      }
    },
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    async changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.insuredValue = ''
        this.formData.declaredValue = ''
      }
      const { goods, declaredValue, expressTypeCode } = this.formData
      if (val === 1 && goods && declaredValue && parseFloat(declaredValue) && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = ''
      }
    },
    changeBoxStandard(val) {
      if (!val) {
        this.formData.boxPrice = 0
      }
      if (val && val.salesPrice) {
        const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
        Object.assign(this.formData, {
        // 箱材规格id
          boxStandardId,
          // 箱材规格名称
          boxStandardName,
          // 箱材单价
          boxPrice,
        })
      }
    },
    // 获取币别  sysCurrencyType/list
    async getCurrencyTypeList() {
      const { data, code, msg } = await getsysCurrencyType()
      // debugger
      var dataList = []
      if (code === RESPONSE_SUCCESS) {
        for (let p = 0; p < data.length;p++) {
          dataList.push({ codCurrencyTypeCode: data[p].code, codCurrencyTypeName: data[p].enName })
        }
        // console.log(dataList)
        this.codCurrencyType = dataList
      } else {
        this.$message.error(msg)
      }
    },
    // 获取酋长国数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
        console.log(this.provinceArray)
      } else {
        this.$message.error(msg)
      }
    },

    dataProvinceChange(value, flag) {
      console.log(value)
      this.getCityList(value, flag)
    },

    dataCityChange(value, num) {
      console.log(value)
      // debugger
      if (num === 1) {
        this.formData.senderCityId = value
        const obj = this.cityList.find((item) => {
          return item.id === value
        })
        this.formData.senderCityName = obj[this.labelLang] + '（' + obj.enName + '）'
        this.getAreaList(value, num)
      } else {
        this.formData.receiverCityId = value
        const obj = this.cityList2.find((item) => {
          return item.id === value
        })
        this.formData.receiverCityName = obj[this.labelLang] + '（' + obj.enName + '）'
        this.getAreaList(value, num)
      }
    },

    dataAreaChange(value, num) {
      console.log(value)
      // debugger
      if (num === 1) {
        this.formData.senderAreaId = value.id
        const obj = this.areaList.find((item) => {
          return item.id === value.id
        })
        this.formData.senderAreaName = obj[this.labelLang] + '（' + obj.enName + '）'
      } else {
        this.formData.receiverAreaId = value.id
        const obj = this.areaList2.find((item) => {
          return item.id === value.id
        })
        this.formData.receiverAreaName = obj[this.labelLang] + '（' + obj.enName + '）'
      }
    },
    blurCity (val, type) {
      console.log(val.target.value, type)
      if (type === 1) {
        const hasCity = this.areaList.find(item => item.nativeName === val.target.value)
        hasCity ? this.formData.senderAreaId = hasCity.id : this.formData.senderAreaId = ''
        console.log('1----------------', val.target.value, hasCity)
      } else {
        const hasCity = this.areaList2.find(item => item.nativeName === val.target.value)
        hasCity ? this.formData.receiverAreaId = hasCity.id : this.formData.receiverAreaId = ''
        console.log('2----------------', val.target.value, hasCity)
      }
    },
    querySearch(queryString, cb) {
      var restaurants = cloneDeep(this.areaList)
      console.log(queryString)
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter2(queryString)) : restaurants
      var listPam = []
      if (results.length > 0) {
        results.forEach((item) => {
          if (this.labelLang === 'nativeName') {
            listPam.push(Object.assign(item, { nativeName: (item[this.labelLang] + '（' + item.enName + '）') }))
          } else {
            listPam.push(Object.assign(item, { enName: (item[this.labelLang] + '（' + item.enName + '）') }))
          }
        })
      }
      console.log('llllllll', listPam)
      // 调用 callback 返回建议列表的数据
      cb(listPam)
    },
    querySearch2(queryString, cb) {
      var restaurants = cloneDeep(this.areaList2)
      console.log(queryString)
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter2(queryString)) : restaurants
      var listPam = []
      if (results.length > 0) {
        results.forEach((item) => {
          if (this.labelLang === 'nativeName') {
            listPam.push(Object.assign(item, { nativeName: (item[this.labelLang] + '（' + item.enName + '）') }))
          } else {
            listPam.push(Object.assign(item, { enName: (item[this.labelLang] + '（' + item.enName + '）') }))
          }
        })
      }
      console.log('llllllll', listPam)
      // 调用 callback 返回建议列表的数据
      cb(listPam)
    },
    createFilter2(queryString) {
      return (restaurant) => {
        var restaurantVal = restaurant[this.labelLang] + '（' + restaurant.enName + '）'
        return (restaurantVal.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    // 获取城市数据
    async getCityList(parentId, flag) {
      // const { data, code, msg } = await this.$selectApi.reqSysArea({ parentId })
      // debugger
      if (parentId) {
        const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
        if (code === RESPONSE_SUCCESS) {
          if (flag === 1) {
            this.cityList = data
            this.formData.senderProvinceId = parentId
            // this.formData.senderCityId = data[0].id
            // this.formData.senderCityName = data[0][this.labelLang] + '（' + data[0].enName + '）'
            // this.getAreaList(data[0].id, flag)
            this.formData.senderCityId = ''
            this.formData.senderCityName = ''
            this.formData.senderAreaId = ''
            this.formData.senderAreaName = ''
            let obj = {}
            obj = this.provinceArray.find((item) => {
              return item.id === parentId
            })
            this.formData.senderProvinceName = obj[this.labelLang] + '（' + obj.enName + '）'
          } else if (flag === 2) {
            this.cityList2 = data
            this.formData.receiverProvinceId = parentId
            // this.formData.receiverCityId = data[0].id
            // this.formData.receiverCityName = data[0][this.labelLang] + '（' + data[0].enName + '）'
            // this.getAreaList(data[0].id, flag)
            this.formData.receiverCityId = ''
            this.formData.receiverCityName = ''
            this.formData.receiverAreaId = ''
            this.formData.receiverAreaName = ''
            let obj = {}
            obj = this.provinceArray.find((item) => {
              return item.id === parentId
            })
            this.formData.receiverProvinceName = obj[this.labelLang] + '（' + obj.enName + '）'
          }
        } else {
          this.$message.error(msg)
        }
      }
    },

    // 获取区域数据
    async getAreaList(parentId, flag) {
      // const { data, code, msg } = await this.$selectApi.reqSysArea({ parentId })
      // debugger
      if (parentId) {
        const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 4, parentId: parentId })
        if (code === RESPONSE_SUCCESS) {
          if (flag === 1) {
            this.areaList = data
            this.formData.senderCityId = parentId
            // this.formData.senderAreaId = data[0].id
            // this.formData.senderAreaName = data[0][this.labelLang] + '（' + data[0].enName + '）'
            this.formData.senderAreaId = ''
            this.formData.senderAreaName = ''
            let obj = {}
            obj = this.cityList.find((item) => {
              return item.id === parentId
            })
            this.formData.senderCityName = obj ? (obj[this.labelLang] + '（' + obj.enName + '）') : ''
          } else if (flag === 2) {
            this.areaList2 = data
            this.formData.receiverCityId = parentId
            // this.formData.receiverAreaId = data[0].id
            // this.formData.receiverAreaName = data[0][this.labelLang] + '（' + data[0].enName + '）'
            this.formData.receiverAreaId = ''
            this.formData.receiverAreaName = ''
            let obj = {}
            obj = this.cityList2.find((item) => {
              return item.id === parentId
            })
            this.formData.receiverCityName = obj ? (obj[this.labelLang] + '（' + obj.enName + '）') : ''
          }
          // console.log(this.cityList)
        } else {
          this.$message.error(msg)
        }
      }
    },
    sumbit() {
      // if (this.formData.paymentModeId === 321 && this.formData.insured !== 0) {
      //   this.$message.error(this.$lang('到付件不支持保价'))
      //   return
      // }
      const { insured, declaredValue, codMoney } = this.formData
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('保险价值必须大于0'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.insuredValue && this.formData.insuredValue !== 0)) {
        this.$message.error(this.$lang('未找到保价费报价'))
        return
      }
      if (insured === 1 && codMoney && (declaredValue > +codMoney)) {
        this.$message.error(this.$lang(`Your insurance value shouldn't be higher than the COD amount.`))
        return
      }
      // debugger
      this.$emit('editSave', this.formData)
    },
    close() {
      this.$emit('editClose', false)
    },
    // 运费计算
    calcStandardCost: debounce(async function(data) {
      const { senderProvince, receiverProvince, packageTotalWeight, paymentModeId } = data
      const result = {
        // 寄件省份id
        senderProvinceId: senderProvince.provinceId,
        // 寄件省份名称
        senderProvinceName: senderProvince.provinceName,
        // 寄件城市id
        senderCityId: senderProvince.cityId,
        // 寄件城市名称
        senderCityName: senderProvince.cityName,
        // 寄件区域id
        senderAreaId: senderProvince.areaId,
        // 寄件区域名称
        senderStreet: senderProvince.areaName,
        // 收件省份id
        receiverProvinceId: receiverProvince.provinceId,
        // 收件省份名称
        receiverProvinceName: receiverProvince.provinceName,
        // 收件城市id
        receiverCityId: receiverProvince.cityId,
        // 收件城市名称
        receiverCityName: receiverProvince.cityName,
        // 收件区域id
        receiverAreaId: receiverProvince.areaId,
        // 收件区域名称
        receiverStreet: receiverProvince.areaName,
      }
      // 运费
      const obj = {}
      if (result.senderAreaId && result.receiverAreaId) {
        const promises = [
        // 获取起始地址ID
          this.getSettlement(result.senderProvinceId, result.senderCityId, result.senderAreaId),
          // 获取目的地地址ID
          this.getSettlement(result.receiverProvinceId, result.receiverCityId, result.receiverAreaId),
        ]
        const [startAddressId, endAddressId] = await Promise.all(promises)
        // 如果起始地址且目的地地址ID存在
        if (startAddressId && endAddressId) {
          // 获取运费
          const res = await this.getComCost(packageTotalWeight, startAddressId, endAddressId, paymentModeId)
          obj.standardValue = res.cost
          obj.settlementWeight = res.setWeight
          this.formData.standardValue = res.cost
        }
      }
      // 返回结果
      return {
        ...result,
        ...obj,
      }
    }, 200),
    // 查询数据
    async handleProvice(provinceId, flagType) {
      if (provinceId) {
        const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: provinceId })
        if (code === RESPONSE_SUCCESS) {
          if (flagType === 1) {
            this.cityList = data
          } else {
            this.cityList2 = data
          }
        } else {
          this.$message.error(msg)
        }
      }
    },
    // 查询地区
    async hangdleAreaInfo (provinceId, flagType) {
      if (provinceId) {
        const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 4, parentId: provinceId })
        if (code === RESPONSE_SUCCESS) {
          if (flagType === 1) {
            this.areaList = data
          } else {
            this.areaList2 = data
          }
        } else {
          this.$message.error(msg)
        }
      }
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, areaId, packageTotalWeight, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === 1 && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId) {
      let smMode = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smMode = 1
            break
          case 319:
            smMode = 2
            break
          case 321:
            smMode = 3
            break
        }
      }
      const reqData = { startAddressId, endAddressId, number, smMode }
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    // 保价费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
        productTypeCode: param.expressTypeCode // 产品类型
      }
      // 调用接口
      // const { data } = await getComputationCost(params)
      const { code, msg, data } = await getComputationCost(params)
      if (code !== RESPONSE_SUCCESS) {
        this.$message.error(this.$lang(msg))
        this.formData.declaredValue = 0 // 清空保险价值
      }
      return data === 0 ? 0 : data || 0
    },
  },
}
</script>

<style lang="scss" scoped>
body {
  ::v-deep .my-kqoption {
    width: auto !important;
  }
}
.el-autocomplete {
  ::v-deep .my-kqoption {
    width: auto !important;
  }
}

.sizeSty {
  ::v-deep .el-form-item__label {
    min-width:450px !important;
  }
}
.sizeSty {
   ::v-deep .el-form-item__content {
    min-width:450px !important;
  }
}
.sizeSty {
   ::v-deep .el-input{
     width: 80px !important;
   }
}

.sendRemarkStyle {
  ::v-deep .el-input__inner{
    width: 360px;
  }
}
.group-title {
  border-bottom: 1px dashed #eeeeee;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;
  .title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #e0bd7b;
  }
  .insert-info {
    display: inline-block;
    margin-left: 60px;
    position: relative;
    .icon {
      color: #e0bd7b;
      position: absolute;
      overflow: visible;
    }
    .text {
      color: #666666;
      margin-left: 20px;
    }
  }
}
.el-form-item {
  padding: 0px 8px 18px 8px !important;
}
.group-content{
    background: #f7f7f9;
    padding: 20px 20px 10px;
    border-radius: 8px;
}
 .w360 .el-input{
        width: 360px !important;
    }

  .isSigndan {
    display: flex;
    margin-top: 20px;

    .tit {
      margin-left: 5px;
    }
  }
</style>
<style lang="scss">
.el-dialog__wrapper .el-dialog.j-dialog{
  margin-bottom: 0!important;
}
.el-dialog__wrapper .el-dialog.j-dialog .el-dialog__body{
  max-height: 700px;
  overflow: auto;
  padding:10px 20px;
  .dialog-footer{
      border-top:0;
      margin-top: 0px;
      margin-bottom:20px;
  }
}
</style>
<style lang="scss">
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content{
  position: relative;
  .btn-insured{
    // color: #2D7CFF;
    color: #e60012;;
    font-size: 12px;
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: -22px;
    display: inline-block;
    height: 22px;
    line-height: 16px;
    &:hover{
      text-decoration: underline;
    }
  }
}
</style>
